export default "__VITE_ASSET__BNGNbfAq__"